import { Component, computed, effect, EffectRef, ElementRef, inject, Signal, ViewChild } from '@angular/core';
import { Configuration } from '../../../models/interfaces/configuration/index.interface';
import { APP_CONFIG } from '../../../configuration/configuration';
import { DvmService } from '@services/dvm.service';
import { ActivatedRoute } from '@angular/router';
import { AppViews } from '@models/enums/dvm/DvmViews.enum';
import anime from 'animejs';
import { CommonModule } from '@angular/common';


@Component({
  selector: 'app-logo',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './logo.component.html',
  styleUrl: './logo.component.css'
})
export class LogoComponent  {

  @ViewChild('logo', { static: true})
  private readonly logoElement!:  ElementRef<HTMLDivElement>;

  // SERVICES
  private readonly route:         ActivatedRoute             = inject(ActivatedRoute);
  private readonly dvmService:    DvmService                 = inject(DvmService);

  // CONFIGURATION
  private readonly configuration: Signal<Configuration>      = inject(APP_CONFIG);

  // STATE
  protected readonly hasViewId:  boolean                    = this.route.snapshot.queryParamMap.has('view_id');
  private readonly view:         Signal<AppViews | null>     = this.dvmService.view;
  public           showElement:  boolean                     = false;

  // LOGO DATA
  protected readonly logo:        Signal<string>             = computed((): string => this.configuration().General.client.logo);

  // LOGO TITLE
  protected readonly logoTitle:   Signal<string>             = computed((): string => this.configuration().General.client.name);

  
  // EFFECTS
  private  readonly  onViewChange: EffectRef                 = effect((): void => {

    const view: AppViews | null = this.view();

    if(view === null) return;

    this.animateLogo();

  })

  // METHODS
  protected restartNavigation():  void {
    
    const viewParam: string | null = this.route.snapshot.queryParamMap.get('view_id');

    if(viewParam) return;

    this.dvmService.resetViewer();

  }

  protected animateLogo(): void {

    if(this.showElement) return; // Si ya está visible no hacemos nada

    anime({
      targets:  this.logoElement.nativeElement,
      opacity:  1,
      duration: 500,
      easing:   'easeInOutQuad',
      complete: (): boolean => this.showElement = true
    })

  }

  protected get logoSrc(): string {
    return this.logo();
  }

}
